import { List, ListProps } from '@chakra-ui/react';

// Creates unstyled list with variants support but renders an ol. Chakra's OrderedList cant be easily reset and used as "as"
const OrderedList = (props: ListProps) => <List {...props} as="ol" />;

export default OrderedList;
